import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import BreedServices from '../components/BreedServices';
import BreadCumb from '../components/doglists/BreadCumb';
import Faq from '../components/Faq';
import ShopArea from '../components/ourshop/ShopArea';


function DogList() {

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, []);

	return (

		<main>
			<Helmet>
				<title>Chiens - Animalia</title>
				<meta name="description" content="Découvrez notre sélection de nos produits pour chiens chez Animalia." />
			</Helmet>

			<BreadCumb />
			{/* <DogsList/> */}
			<ShopArea />
			{/* <AdoptionShop/> */}
			<Faq afterElment="faq-area-two" />
			<BreedServices />
			{/* <NewsLetter /> */}
		</main>
	)
}

export default DogList;
